<p-fieldset legend="Endereço">
  <form #f="ngForm" autocomplete="off">
    <div class="ui-g">
      <div class="ui-g-8">
        <div class="ui-g form-group" *ngIf="endereco">
          <!-- lat: {{ endereco?.geom?.coordinates?.lat }}
          visible: {{ endereco?.geom?.coordinates?.lat }} -->

          <div class="ui-g-12">
            <app-endereco-mensagens-de-aviso
              [f]="f"
              [endereco]="endereco"
              [novaLocalizacao]="novaLocalizacao">
            </app-endereco-mensagens-de-aviso>
          </div>

          <div class="ui-g-4">
            <span class="md-inputfield">
              <input
                type="number"
                #campoCEP
                name="cep"
                id="cep"
                [(ngModel)]="endereco.cep"
                class="full-width"
                (keyup.enter)="buscarEnderecoPorCep($event);"
                (keyup)="cepKeyUp()"
                [required]="true"
                maxlength="8"
                pInputText>
                <label>CEP</label>
            </span>
          </div>
          <div class="ui-g-8">
            <button
              [id]="'buscarEnderecoPorCep'"
              class="botao ui-button-secondary botao-validar-cep tamanho-botao"
              type="button"
              [disabled]="!(campoCEP.value && campoCEP.value.length === 8)"
              pButton
              (click)="buscarEnderecoPorCep()"
              iconPos="right"
              label="Completar">
            </button>

            <button
              [id]="'limparEndereco'"
              class="botao ui-button-secondary botao-limpar-endereco tamanho-botao"
              type="button"
              pButton
              (click)="limparEndereco(true)"
              iconPos="right"
              label="Limpar">
            </button>

            <button
              *ngIf="exibirBotaoSalvar"
              [id]="'salvarEndereco'"
              class="botao ui-button-info botao-salvar tamanho-botao"
              type="button"
              [disabled]="!enderecoEstaValido()"
              pButton
              (click)="salvarEndereco()"
              label="Salvar">
            </button>

            <span class="botao-preencher-endereco-com-mapa" align="right" *ngIf="locationParaPreencherEndereco">
              <button
                [id]="'preencherEnderecoComBaseNoMapa'"
                class="botao ui-button-secondary botao-validar-cep"
                type="button"
                pButton
                (click)="preencherEnderecoComBaseNoMapa($event)"
                iconPos="right"
                label="Procurar">
              </button>
            </span>
          </div>

          <div class="ui-g-12">
            <span class="md-inputfield">
              <input
                type="text"
                autocomplete="no1"
                name="logradouro"
                id="logradouro"
                [(ngModel)]="endereco.logradouro"
                class="full-width"
                [required]="true"
                pInputText>
                <label>Endereço</label>
            </span>
          </div>

          <div class="ui-g-2">
            <span class="md-inputfield">
              <input
                type="text"
                name="numero"
                id="numero"
                autocomplete="no"
                [(ngModel)]="endereco.numero"
                class="full-width"
                [required]="true"
                pInputText>
                <label>Número</label>
            </span>
          </div>

          <div class="ui-g-10">
            <span class="md-inputfield">
              <input
                type="text"
                name="complemento"
                id="complemento"
                [(ngModel)]="endereco.complemento"
                class="full-width"
                pInputText>
                <label>Complemento (opcional)</label>
            </span>
          </div>

          <div class="ui-g-12">
            <span class="md-inputfield">
              <input
                type="text"
                name="bairro"
                id="bairro"
                [(ngModel)]="endereco.bairro"
                class="full-width"
                [required]="true"
                pInputText>
                <label>Bairro</label>
            </span>
          </div>

          <div class="ui-g-2">
            <span class="md-inputfield">
              <input
                type="text"
                name="estado"
                id="estado"
                [value]="endereco.estado?.sigla"
                class="full-width"
                [disabled]="true"
                [required]="false"
                pInputText>
                <label>UF</label>
              <!-- <p-dropdown
                name="estado"
                tabindex="1"
                [style]="{'width':'100%'}"
                [options]="estados"
                optionLabel="nome"
                [disabled]="true"
                [autoDisplayFirst]="false"
                [showClear]="true"
                placeholder="Estado"
                [(ngModel)]="estadoSelecionado"
                (onChange)="estadoOnChange($event)" >
              </p-dropdown> -->
            </span>
          </div>

          <div class="ui-g-10">
            <span class="md-inputfield">
              <input
                type="text"
                name="cidade"
                id="cidade"
                [value]="endereco.cidade ? endereco.cidade.nome : ''"
                class="full-width"
                [disabled]="true"
                [required]="false"
                pInputText>
                <label>Cidade</label>
              <!-- <p-autoComplete
                  *ngIf="autocompleteCidade"
                  #autocompleteCidadeViewChild
                  [style]="{'width':'100%'}"
                  [inputStyle]="{'width':'100%'}"
                  name="autocompleteCidade"
                  inputId="autocompleteCidade"
                  [tabindex]=1
                  field="nome"
                  [(ngModel)]="autocompleteCidade.itemSelecionado"
                  [suggestions]="autocompleteCidade.resultset"
                  [dropdown]="true"
                  [readonly]="true"
                  [disabled]="true"
                  [filter]="true"
                  [size]="autocompleteCidade.resultsetMaxSize"
                  [forceSelection]="true"
                  [required]="false"
                  (completeMethod)="autocompleteCidade.buscarItem($event)">
              </p-autoComplete>
              <label>Cidade</label> -->
            </span>
          </div>

        </div>
      </div>

      <div class="ui-g-4">
        <app-endereco-mapa
          #enderecoMapa
          *ngIf="endereco"
          [latitude]="endereco?.geom?.coordinates?.lat"
          [longitude]="endereco?.geom?.coordinates?.lng"
          (adicionarMarcadorEvent)="adicionarMarcadorEvent($event)"
          (novaLocalizacaoEvent)="novaLocalizacaoEvent($event)"
          (novaLocalizacaoParaPreencherEnderecoEvent)="novaLocalizacaoParaPreencherEnderecoEvent($event)">
        </app-endereco-mapa>
      </div>
    </div>

    <!-- <pre>end: {{ endereco | json }} </pre> -->
  </form>
</p-fieldset>
